import * as React from 'react';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
import { useSplitNavItem_unstable } from './useSplitNavItem';
import { renderSplitNavItem_unstable } from './renderSplitNavItem';
import { useSplitNavItemStyles_unstable } from './useSplitNavItemStyles.styles';
/**
 * SplitNavItem component - TODO: add more docs
 */ export const SplitNavItem = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useSplitNavItem_unstable(props, ref);
    useSplitNavItemStyles_unstable(state);
    useCustomStyleHook_unstable('useSplitNavItemStyles_unstable')(state);
    return renderSplitNavItem_unstable(state);
});
SplitNavItem.displayName = 'SplitNavItem';
